var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 576",
    height: 768,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8f526e8e09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46b669f652"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 281.710938 57.710938 L 741.988281 57.710938 L 741.988281 517.988281 L 281.710938 517.988281 Z M 281.710938 57.710938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f526e8e09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0.140625 L 1024 0.140625 L 1024 575.859375 L 0 575.859375 Z M 0 0.140625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 533.953125 218.828125 L 533.953125 256.246094 L 581.066406 256.246094 L 574.472656 307.433594 L 533.953125 307.433594 L 533.953125 424.730469 L 482.574219 424.730469 L 482.574219 307.433594 L 438.5625 307.433594 L 438.5625 256.246094 L 482.574219 256.246094 L 482.574219 218.828125 C 482.574219 178.308594 515.339844 150.96875 555.863281 150.96875 C 573.699219 150.96875 584.945312 153.683594 584.945312 153.683594 L 584.945312 196.917969 L 555.863281 196.917969 C 543.839844 196.917969 533.953125 206.808594 533.953125 218.828125 Z M 533.953125 218.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46b669f652)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 511.851562 517.988281 C 385.050781 517.988281 281.710938 414.84375 281.710938 287.851562 C 281.710938 160.859375 385.050781 57.710938 511.851562 57.710938 C 638.84375 57.710938 741.988281 161.050781 741.988281 287.851562 C 741.988281 414.648438 638.84375 517.988281 511.851562 517.988281 Z M 511.851562 70.316406 C 391.835938 70.316406 294.316406 167.835938 294.316406 287.851562 C 294.316406 407.863281 391.835938 505.386719 511.851562 505.386719 C 631.863281 505.386719 729.386719 407.863281 729.386719 287.851562 C 729.386719 167.835938 631.863281 70.316406 511.851562 70.316406 Z M 511.851562 70.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.61f48dd04a420d1c12974971c2a9663f.svg";
export { ForwardRef as ReactComponent };